export default __webpack_public_path__ + "static/media/daa166ab02c4bfcec807b3a0cd958ff0.svg";